// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__31Xbi","header":"ClearentDisclaimer_header__1X3lZ","inner":"ClearentDisclaimer_inner__37Qwx"};